import {Tag} from 'antd';
import {useMasterAccountQuery, useStoreQuery} from 'api/generated';
import {useCountries} from 'hooks/useCountries';
import {fromCents} from 'lib/utils';
import {NO_STORE_VALUE} from 'routes/Account/Payout/PayoutSettings';

type queryFilters = Record<string, string | boolean | null | undefined>;
type filters = Record<string, string>;

type Props = {
  fieldName: string;
  value: string | number | boolean | null | undefined;
  filters: filters;
  queryFilters: queryFilters;
  handleOnClose: (key: string) => void;
  accountId?: string;
};

const AMOUNT_OPERATORS = {
  eq: '=',
  gt: '>',
  gte: '>=',
  lt: '<',
  lte: '<='
};

export const FilterTag: React.FC<Props> = ({
  fieldName,
  value,
  filters,
  queryFilters,
  handleOnClose,
  accountId
}) => {
  const {getCountryName} = useCountries();
  const {data, loading} = useMasterAccountQuery({
    variables: {id: value as string},
    skip: fieldName !== 'masterAccountId'
  });

  const {data: store, loading: loadingStore} = useStoreQuery({
    skip: fieldName !== 'storeId' || value === NO_STORE_VALUE || !accountId,
    variables: {
      id: value as string,
      accountId
    }
  });

  const getLabel = (key: string, filters: filters, queryFilters: queryFilters): string => {
    switch (key) {
      case 'amount':
        return `${filters['amount']} ${
          AMOUNT_OPERATORS[queryFilters.amountOperator as keyof typeof AMOUNT_OPERATORS]
        } `;
      default:
        return `${filters[key as keyof typeof filters]}: `;
    }
  };

  const getValue = (key: string, value: unknown) => {
    switch (key) {
      case 'amount':
        return fromCents(value as number) || value;
      case 'shopCountry':
        return getCountryName(value as string) || value;
      case 'masterAccountId':
        return loading ? '...' : data?.masterAccount?.name || value;
      case 'storeId':
        return loadingStore ? '...' : value === NO_STORE_VALUE ? 'No' : store?.store?.name || value;
      default:
        return value;
    }
  };
  return (
    <Tag key={fieldName} closable onClose={() => handleOnClose(fieldName)}>
      {getLabel(fieldName, filters, queryFilters)}
      {getValue(fieldName, value)?.toString()}
    </Tag>
  );
};
